export type TextareaProps = {
  name: string;
  label?: string;
  placeholder?: string;
  height?:string;
  rows?: number;
  className?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  disabled?: boolean;
};

const TextareaField: React.FC<TextareaProps> = ({
  name,
  label,
  placeholder,
  className,
  rows,
  value,
  height,
  onChange,
  error,
  disabled = false,
}) => {
  return (
    <div className={`${className} relative mb-4 w-full`}>
      {label && (
        <label
          htmlFor={name}
          className="block pb-1 text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <textarea
          id={name}
          name={name}
          style={{height:height}}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          rows={rows}
          className={`placeholder:font-normal text-sm placeholder:text-[ #959FB2] placeholder:text-sm leading-5 mt-1 resize-none  block w-full py-2.5 px-4 border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-[8px] shadow-sm focus:outline-none focus:ring-secondary ${
            error ? "focus:border-red-500" : "focus:border-secondary"
          }`}
          disabled={disabled}
        />
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default TextareaField;
